import { useState, type ReactNode, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function TenantCreatePage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      await apiRequest('/platform/tenants', { token, method: 'POST', body: { tenantCode: code, displayName: name } });
      nav('/admin/tenants');
    } catch (err) { setError((err as Error).message); setSaving(false); }
  };

  return (
    <main aria-label="tenant-create">
      <h1>{t('tenants.create.title')}</h1>
      {error && <p role="alert">{error}</p>}
      <form onSubmit={onSubmit} aria-label="tenant-form">
        <label>{t('tenants.create.code')} <input value={code} onChange={(e) => setCode(e.target.value)} required /></label>
        <label>{t('tenants.create.name')} <input value={name} onChange={(e) => setName(e.target.value)} required /></label>
        <button type="submit" disabled={saving}>{saving ? t('tenants.create.saving') : t('tenants.create.submit')}</button>
      </form>
    </main>
  );
}
